import React, { useState } from 'react';
import { Form, Input, Table, Row, Col } from 'antd';
import validator from '@/common/validator';
import { prefixCls } from '@/constants';

function validateErpRepeat(values, value) {
  const cache = {};

  values.forEach((item) => {
    // true 表示存在并且唯一 false表示重复
    cache[item] = true;
  });

  // 是否通过校验
  let valid = true;
  value.forEach((item) => {
    if (cache[item.erp]) {
      valid = false;
      cache[item.erp] = false;
    }
  });

  // 收集错误信息
  let msg = '';
  if (!valid) {
    // 收集重复的erp
    // const repeatedErps = Object.keys(cache).filter(key => !cache[key])
    // msg = 'ERP：' + repeatedErps.join(',') + '异常'
    msg = '请输入有效的erp账号';
  }

  return { valid, msg };
}

// 通过接口查询erp是否合法
async function validateErpOk(values) {
  try {
    await validator.validateErp(undefined, values);
    return {
      valid: true,
      msg: '',
    };
  } catch (ex) {
    return {
      valid: false,
      msg: ex.message,
    };
  }
}

async function validateErps(values, value) {
  let res = validateErpRepeat(values, value);

  if (!res.valid) return res;

  res = await validateErpOk(values, value);

  return res;
}

export default function OpenForUser(props) {
  const { onChange = () => {}, value = [] } = props;
  const [errMsg, setErrMsg] = useState('');
  const [erp, setErp] = useState('');

  const columnsUser = [
    {
      title: 'erp',
      dataIndex: 'erp',
      align: 'center',
    },
    {
      align: 'center',
      title: '操作',
      dataIndex: 'erp',
      width: 100,
      render: (erp) => (
        <a
          onClick={() => {
            onChange(value.filter((item) => item.erp !== erp));
          }}
        >
          删除
        </a>
      ),
    },
  ];

  // 提交数据到formData中
  async function handleOnEnter(e) {
    e.preventDefault();
    const values = e.target.value.split(',').map((item) => item.trim());

    const validateRes = await validateErps(values, value);

    if (validateRes.valid) {
      // TODO: 先删除再添加同样的erp怎么办？ 后端说没关系
      const _values = values.map((item) => ({ id: null, erp: item }));
      onChange(_values.concat(value));
      setErp('');
      if (errMsg) setErrMsg('');
    } else {
      if (validateRes.msg) setErrMsg(validateRes.msg);
    }
  }

  return (
    <div className="wrap-select-open-scope">
      <Row>
        <Col span={7}>
          <Form.Item
            validateStatus={errMsg ? 'error' : ''}
            className={`${prefixCls}-form-item-has-error}`}
            label="添加用户:"
            style={{ position: 'relative' }}
          >
            <Input
              onChange={(e) => {
                setErp(e.target.value);
                setErrMsg('');
              }}
              value={erp}
              placeholder="请输入ERP（回车添加）"
              onPressEnter={handleOnEnter}
            />
            <span className="self-err-msg">{errMsg || null}</span>
          </Form.Item>
        </Col>
      </Row>
      <Form.Item noStyle>
        <Table className="table-width" rowKey="erp" pagination={false} columns={columnsUser} dataSource={value} />
      </Form.Item>
    </div>
  );
}
